import React, { lazy, Suspense } from 'react'
import { Route, Switch, useHistory } from 'react-router-dom'
import Auth from '../../../../Layout/Auth'
import LoadingOverlay from 'react-loading-overlay'
import FadeLoader from 'react-spinners/FadeLoader'

// Lazy pages
const KitchenDisplayList = lazy(() => import('../Pages/KitchenDisplayList'))
const AddKitchenDisplay = lazy(() => import('../Pages/AddKitchenDisplay'))
const EditKitchenDisplay = lazy(() => import('../Pages/EditKitchenDisplay'))
const ViewKitchenDisplay = lazy(() => import('../Pages/ViewKitchenDisplay'))

LoadingOverlay.propTypes = undefined

function Loading() {
  return (
    <>
      <div className='wrapperContainer'>
        <div className='loader-body'>
          <LoadingOverlay
            active={true}
            spinner={<FadeLoader color={'#ccc !important'} size={50} />}
            styles={{
              overlay: (base) => ({ ...base, background: 'transparent' })
            }}
          >
            <div style={{ height: '100px' }} />
          </LoadingOverlay>
        </div>
      </div>
    </>
  )
}

function KitchenDisplayRoute() {
  const history = useHistory()

  return (
    <Switch>
      <Route
        exact
        path='/:lng/restaurant/kitchen-display'
        render={() => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <Suspense fallback={<Loading />}>
              <KitchenDisplayList history={history} />
            </Suspense>
          </Auth>
        )}
      />

      <Route
        exact
        path='/:lng/restaurant/kitchen-display/list'
        render={() => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <Suspense fallback={<Loading />}>
              <KitchenDisplayList history={history} />
            </Suspense>
          </Auth>
        )}
      />

      <Route
        exact
        path='/:lng/restaurant/kitchen-display/add'
        render={() => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <Suspense fallback={<Loading />}>
              <AddKitchenDisplay history={history} />
            </Suspense>
          </Auth>
        )}
      />

      <Route
        exact
        path='/:lng/restaurant/kitchen-display/edit/:slack'
        render={(props) => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <Suspense fallback={<Loading />}>
              <EditKitchenDisplay {...props} history={history} />
            </Suspense>
          </Auth>
        )}
      />

      <Route
        exact
        path='/:lng/restaurant/kitchen-display/view/:slack'
        render={(props) => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <Suspense fallback={<Loading />}>
              <ViewKitchenDisplay {...props} history={history} />
            </Suspense>
          </Auth>
        )}
      />
    </Switch>
  )
}

export default KitchenDisplayRoute
